// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var WebStore = require("../store/WebStore.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var CommonTypes_UTMParams = require("../../../shared/src/types/CommonTypes_UTMParams.bs.js");
var WebStore_Types_Action = require("../store/WebStore_Types_Action.bs.js");
var BrowserComponents_Button = require("../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var WebComponents_SimpleCenteredLogoPage = require("../components/WebComponents_SimpleCenteredLogoPage.bs.js");

function WebContainers_Welcome$Presentation(Props) {
  var setView = Props.setView;
  return React.createElement(WebComponents_SimpleCenteredLogoPage.make, {
              children: null,
              title: "changing the way people work"
            }, React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Large */5
                }), React.createElement(BrowserComponents_Button.make, {
                  actionPriority: /* Legacy */{
                    backgroundColor: {
                      TAG: /* Blue */0,
                      _0: /* Darkest */0
                    },
                    textColor: {
                      TAG: /* White */7,
                      _0: /* Light */2
                    }
                  },
                  onClick: (function (param) {
                      return Curry._1(setView, {
                                  TAG: /* Signup */6,
                                  _0: {
                                    TAG: /* Professional */1,
                                    _0: {
                                      TAG: /* PersonalInfo */0,
                                      maybeReferralCode: undefined,
                                      utmParams: CommonTypes_UTMParams.empty
                                    }
                                  }
                                });
                    }),
                  title: "I'M LOOKING FOR WORK"
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Medium */4
                }), React.createElement(BrowserComponents_Button.make, {
                  actionPriority: /* Primary */0,
                  onClick: (function (param) {
                      return Curry._1(setView, {
                                  TAG: /* Signup */6,
                                  _0: {
                                    TAG: /* Business */0,
                                    _0: {
                                      TAG: /* BusinessInfo */0,
                                      maybeReferralCode: undefined,
                                      utmParams: CommonTypes_UTMParams.empty
                                    }
                                  }
                                });
                    }),
                  title: "I MANAGE A BUSINESS"
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Large */5
                }));
}

var Presentation = {
  make: WebContainers_Welcome$Presentation
};

function mapStateToProps(prim) {
  
}

function mapDispatchToProps(dispatch) {
  var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
          
        }));
  var partial_arg$1 = {
    setView: (function (param) {
        return Relude_Globals.$great$great((function (param) {
                      return Relude_Globals.$great$great(WebStore_Types_Action.setView, dispatch, param);
                    }), partial_arg, param);
      })
  };
  return function (param) {
    return Relude_Globals.$$const(partial_arg$1, param);
  };
}

function WebContainers_Welcome(Props) {
  return React.createElement(WebStore.Provider.make, {
              mapStateToProps: mapStateToProps,
              mapDispatchToProps: mapDispatchToProps,
              children: (function (param, param$1) {
                  return React.createElement(WebContainers_Welcome$Presentation, {
                              setView: param$1.setView
                            });
                })
            });
}

var make = WebContainers_Welcome;

exports.Presentation = Presentation;
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = mapDispatchToProps;
exports.make = make;
/* react Not a pure module */
